import React from 'react';

function Footer(props) {
  return (
    <footer>
      <address>
        Copyright&copy; 2025 CHB allrights reserved.
      </address>
    </footer>
  );
}

export default Footer;